import { render, staticRenderFns } from "./RelationshipArray.vue?vue&type=template&id=cbc32204&scoped=true&"
import script from "./RelationshipArray.vue?vue&type=script&lang=js&"
export * from "./RelationshipArray.vue?vue&type=script&lang=js&"
import style0 from "./RelationshipArray.vue?vue&type=style&index=0&id=cbc32204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc32204",
  null
  
)

export default component.exports